// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_et-6";
export var emphasizeQuantity = "_et-3";
export var flatBottomCorners = "_et-5";
export var productImage = "_et-0";
export var quantityContainer = "_et-2";
export var tooltip = "_et-1";
export var wrapAndEllipsesOverflow = "_et-4";